import { HOME_ROUTE, IDM_FEATURES_ROUTE } from "../../app/router/routes";
import { useAppSelector } from "../../app/store/store";
import { LayoutPages } from "../layoutPages";
import { FEATURES, FEATURE_SECTIONS, hasFeature } from "../../entities/my";
import { IdmFeaturesWidget } from "../../widgets/idmFeatures";
import { AccessDeniedRedirect } from "../../shared/ui/accessDeniedRedirect";

export default function IdmFeaturesPage() {
    const {my} = useAppSelector(s => s.myReducer)
    const isAccess = hasFeature(my, FEATURE_SECTIONS.STAFF)
        && hasFeature(my, FEATURES.IDM.FEATURES_LIST)

    if(!isAccess){
        return <AccessDeniedRedirect to={HOME_ROUTE.path} />
    }

    return (
        <LayoutPages title={IDM_FEATURES_ROUTE.name}>
            <IdmFeaturesWidget />
        </LayoutPages>
    )
}
